import React, {FormEvent, ReactNode} from 'react';

export interface PreventFormProps {
  children: ReactNode;

  noValidate?: boolean;

  onSubmit(e: FormEvent<HTMLFormElement>): void | Promise<void>;
}

function PreventForm({onSubmit, noValidate = false, children}: PreventFormProps): JSX.Element {
  return (
    <form
      noValidate={noValidate}
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit(e);
      }}
    >
      {children}
    </form>
  );
}

export default PreventForm;
